//namespace Pacem.Components.UI {
export var LightboxBehavior;
(function (LightboxBehavior) {
    LightboxBehavior["ClickOutsideClose"] = "clickOutsideClose";
    LightboxBehavior["ExplicitClose"] = "explicitClose";
})(LightboxBehavior || (LightboxBehavior = {}));
